<template>
  <div>
    <div
      class="editor-wrapper d-flex flex-column"
      :class="{ 'errored-field': errors && errors.length }"
    >
      <ck-editor
        ref="descriptionEditor"
        v-if="usersInScope.length > 0"
        :config="descriptionEditorConfig"
        :id="'descriptionEditor-' + initiative.id"
        :initial-data="initiative.description"
        :initial-data-type="initiative.descriptionType"
        :max-height-on-launch="true"
        @save="
          $emit('save', {
            description: $refs.descriptionEditor.getData(),
            notifySubscribers: $refs.submitBar.notifySubscribers
          })
        "
      />
      <submit-buttons
        ref="submitBar"
        class="desc-submit-bar flex-grow-1 align-items-end"
        :show-notify-subscribers="true"
        :is-loading="isLoading"
        @save="
          $emit('save', {
            description: $refs.descriptionEditor.getData(),
            notifySubscribers: $event
          })
        "
        @cancel="$emit('cancel')"
      />
    </div>
    <div class="field-error-message text-medium" v-if="errors && errors.length > 0">
      {{ errors.join('. ') }}
    </div>
  </div>
</template>

<script>
import { getCKEditorConfig } from '@/ckeditorConfig'
import CkEditor from '@/components/CkEditor.vue'
import SubmitButtons from '@/components/SubmitButtons.vue'
import editManager from '@/editManager'
import MembershipsMixin from '@/mixins/MembershipsMixin'

/**
 * This component provides editing capability for Initiative note
 */
export default {
  name: 'InitiativeNoteEditor',
  props: ['errors', 'initiative', 'isLoading'],
  mixins: [MembershipsMixin],
  components: { SubmitButtons, CkEditor },
  data() {
    return {}
  },
  computed: {
    team() {
      return this.$store.getters.teamById(this.initiative.teamId)
    },
    usersInScope() {
      let users = []
      if (this.team.isPrivate) {
        users = this.$store.getters.teamMemberships(this.team.id).map(x => x.user)
      } else {
        users = this.$store.getters.orgMemberships(this.initiative.organizationId).map(x => x.user)
      }
      return users
    },
    descriptionEditorConfig() {
      return getCKEditorConfig({
        startupFocus: true,
        users: this.usersInScope,
        height: 215,
        orgId: this.initiative.organizationId
      })
    }
  },
  methods: {},
  mounted() {
    if (this.usersInScope.length === 0) {
      this.updateMemberships(this.initiative.organizationId, this.team.id, this.team.isPrivate)
    }
    this.descriptionEditId = editManager.enterEditMode()
  },
  beforeDestroy() {
    this.descriptionEditId && editManager.exitEditMode(this.descriptionEditId)
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/errors';
.editor-wrapper {
  padding: 4px 10px 10px 10px;
  margin-bottom: 18px;
  min-height: 313px;
  background-color: $documentColor;
}
</style>
